export default "__VITE_ASSET__D79bSWXi__"